import React, { useState } from "react";
import { CalendarDays } from "lucide-react";
import { it } from "date-fns/locale";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { fmtDay } from "./eaFormat";

const toDate = (s) => (s ? new Date(`${s}T12:00:00`) : undefined);
const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

// Selettore data in formato italiano gg/mm/aaaa.
export function EaDateInput({ value, onChange, min, max, testid }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="h-9 inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-900 font-normal" data-testid={testid}>
          <CalendarDays size={14} className="text-slate-400" /> {value ? fmtDay(value) : "gg/mm/aaaa"}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={it} weekStartsOn={1} selected={toDate(value)} defaultMonth={toDate(value)}
          fromDate={toDate(min)} toDate={toDate(max)}
          onSelect={(d) => { if (d) { onChange(toIso(d)); setOpen(false); } }} />
      </PopoverContent>
    </Popover>
  );
}
